import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { getRelativePath } from "Utils";

import Candidates from "./routes/Candidates";

export default store => ({
  path: "student-membership",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "student-membership" */ "./StudentMembership"
      ),
      import(
        /* webpackChunkName: "ibis-registration-details" */ "DPExamRegistration/modules/DPExamRegistrationModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "dpExamReg",
        reducer,
      });
      return component;
    })
  ),
  onEnter(nextState, replace) {
    const lastRoute = _.last(nextState.routes);
    if (lastRoute.path === "student-membership") {
      const childRoutes = _.get(lastRoute, "childRoutes", []);
      replace(getRelativePath(_.get(_.first(childRoutes), "path", "../")));
    }
  },
  childRoutes: [Candidates(store)],
});
